import { z } from "zod";

export const contratoSchema = z.object({
  id: z.number().int().optional(),
  nome: z.string(),
  // conteudo: z.string(),
  // idAcademia: z.number(),
  // idContratoOriginal: z.number(),
  // idVenda: z.number(),
  // idAluno: z.number(),
  dataInicio: z
    .string()
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Data de Início é obrigatória')
    .refine(value => {
      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
    }, "Data inválida"),
  dataVencimento: z
    .string()
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Data de Vencimento é obrigatória')
    .refine(value => {
      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
    }, "Data inválida"),
});


export type Contrato = z.infer<typeof contratoSchema>;

export interface ContratoEdit {
  idContrato: number;
  nomeContrato: string;
  conteudo: string;
  idContratoOriginal: number;
  nomeAluno: string;
  cpfAluno: string;
  nomePlano: string;
  valorPlano: string; // Considerar mudar para number se possível
  dataInicio: string; // Formato ISO 'YYYY-MM-DD'
  dataVencimento: string;
  emailAluno: string;
  rgAluno: string | null;
  dataNascimento: string;
  sexo: string;
  estadoCivil: string;
  profissao: string | null;
  codigoAluno: string;
  responsavelNome: string;
  responsavelCpf: string;
  responsavelTelefone: string;
  responsavelProfissao: string;
  responsavelEstadoCivil: string | null;
  responsavelRg: string | null;
  endereco: string;
  logradouro: string | null;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  foneResidencial: string | null;
  foneCelular: string | null;
  foneComercial: string | null;
}
